// TODO: CONNECT PRODUCT TO DETAIL PRODUCT PAGE

import React, { useEffect, useState } from 'react'
import { Radio } from '@cmd/library'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch, faSpinner, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

import { httpClient } from '../utils/httpClient';

import ProductItem from '../components/product/Item'
import Select from '../components/form/Select'
import Pagination from '../components/Pagination'
import { splitThousand } from '@cmd/library/lib/utils/function';
import './Gallery.css'
import { parse } from '@fortawesome/fontawesome-svg-core'

const Gallery = () => {
  const [isCar, setIsCar] = useState(window.location.href.split('/')[4] == "mobil")
  // Search parameters
  const [carBrand, setCarBrand] = useState([])
  const [carCities, setCarCities] = useState([])
  const [bikeCities, setBikeCities] = useState([])
  const [bikeBrand, setBikeBrand] = useState([])
  const [bikeConditions, setBikeConditions] = useState([])
  const [carConditions, setCarConditions] = useState([])
  const [bikeYear, setBikeYear] = useState([])
  const [carYear, setCarYear] = useState([])


  const [priceFilter, setPriceFilter] = useState('');
  const [colorFilter, setColorFilter] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [brandFilter, setBrandFilter] = useState(localStorage.getItem("brand"));
  const [cityFilter, setCityFilter] = useState(localStorage.getItem("city"));
  const [conditionFilter, setConditionFilter] = useState(localStorage.getItem("condition"));

  const fetchDataSearch = async () => {
    const result = await httpClient.get('/inventory/search')
    setCarBrand(result.data.car_name)
    setBikeBrand(result.data.bike_name)
    setCarCities(result.data.car_city)
    setBikeCities(result.data.bike_city)
    setCarYear(result.data.carYear)
    setBikeYear(result.data.bikeYear)
  }

  const fetchBikeConditions = async () => {
    const res = await httpClient.get('/bike/search')
    const items = [];
    res.data.condition.map( condition => {
      items.push({
        id: condition,
        value: condition,
        text: condition 
      })
    })
    setBikeConditions(items) // TODO: beautify the string
  }

  const fetchCarConditions = async () => {
    const res = await httpClient.get('/car/search')
    const items = [];
    res.data.condition.map( condition => {
      items.push({
        id: condition,
        value: condition,
        text: condition 
      })
    })
    setCarConditions(items) // TODO: beautify the string
  }

  const setInstallmentString = (amount) => {
    const million = Math.floor(amount/100000)/10;
    if (million > 1) {
      return "Rp " + million + " " + "Jt"
    } else {
      return "Rp " + amount/1000 + " " + "Rb"
    }
  }

  const colorOption = [
    { value: "Merah", label: "Merah" }, 
    { value: "Kuning", label: "Kuning" }, 
    { value: "Orange", label: "Orange" }, 
    { value: "Biru", label: "Biru" }, 
    { value: "Ungu", label: "Ungu" }, 
    { value: "Magenta", label: "Magenta" }, 
    { value: "Violet", label: "Violet" }, 
    { value: "Hijau", label: "Hijau" }, 
    { value: "Hitam", label: "Hitam" }, 
    { value: "Putih", label: "Putih" }, 
    { value: "Cokelat", label: "Cokelat" }, 
    { value: "Abu-abu", label: "Abu-abu" }, 
    { value: "Silver", label: "Silver" }, 
    { value: "Pink", label: "Pink" }, 
    { value: "Gold", label: "Gold" }
  ];

  const priceBikeOptions = {
    name: 'price',
    items: [
      {
        id: 1,
        value: '< 15jt',
        text: '< 15jt'
      },
      {
        id: 2,
        value: '15jt - 20jt',
        text: '15jt - 20jt'
      },
      {
        id: 3,
        value: '20jt - 25jt',
        text: '20jt - 25jt'
      },
      {
        id: 4,
        value: '25jt - 30jt',
        text: '25jt - 30jt'
      },
      {
        id: 5,
        value: '30jt - 40jt',
        text: '30jt - 40jt'
      },
      {
        id: 6,
        value: '> 40jt',
        text: '> 40jt'
      }
    ]
  }

  const priceOptions = {
    name: 'price',
    items: [
      {
        id: 1,
        value: '< 100jt',
        text: '< 100jt'
      },
      {
        id: 2,
        value: '100jt - 200jt',
        text: '100jt - 200jt'
      },
      {
        id: 3,
        value: '200jt - 300jt',
        text: '200jt - 300jt'
      },
      {
        id: 4,
        value: '300jt - 400jt',
        text: '300jt - 400jt'
      },
      {
        id: 5,
        value: '400jt >',
        text: '400jt >'
      }
    ]
  }

  const conditionOptions = {
    name: 'condition',
    items: [
      {
        id: 'Capella',
        value: 'Capella Certified',
        text: 'Capella Certified'
      },
      {
        id: 'Bekas',
        value: 'Bekas',
        text: 'Bekas'
      },
      {
        id: 'Baru',
        value: 'Baru',
        text: 'Baru'
      }
    ]
  }

  const dealOptions = {
    name: 'deals',
    items: [
      {
        id: 'Great',
        value: 'Great Deal',
        text: 'Great Deal'
      },
      {
        id: 'Good',
        value: 'Good Deal',
        text: 'Good Deal'
      },
      {
        id: 'Fair',
        value: 'Fair Deal',
        text: 'Fair Deal'
      }
    ]
  }

  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(0)
  const [offset, setOffset] = useState(0)
  const [totalPage, setTotalPage] = useState(10)

  const fetchInventory = async() => {
    const res = await httpClient.get(
      `/inventory?isCar=${isCar ? 'Mobil' : 'Motor'}&isInternal=false&limit=9&offset=${offset}&brand_id=${brandFilter}&city_id=${cityFilter}&condition=${conditionFilter}&price=${priceFilter}&color=${colorFilter}&year=${yearFilter}`
      )
    setProducts(res.data.rows)
    setTotalPage(parseInt(res.data.count)/9)
    setLoading(false)
  }

  const onChangePage = (data) => {
    // START WITH 0
    setPage(data.selected)
    setOffset(data.selected * 9)
  }

  const onChangeFilter = (filterName, e) => {
    console.log(filterName + " " + e);
    if(filterName == "color") {
      setColorFilter(e);
    }
    if(filterName == "condition") {
      setConditionFilter(e);
    }
    if(filterName == "price") {
      setPriceFilter(e);
    }
    if(filterName == "year") {
      setYearFilter(e);
    }
    if(filterName == "brand") {
      setBrandFilter(e);
    }
    if(filterName == "city") {
      setCityFilter(e);
    }
  }

  const resetFilter = () => {
    window.location.reload();
  }

  useEffect(() => {
    fetchCarConditions();
    fetchBikeConditions();
    fetchDataSearch();
  }, [page])

  useEffect(() => {
    fetchInventory();
  }, [offset, colorFilter, yearFilter, brandFilter, cityFilter, priceFilter, conditionFilter])

  if (loading) {
    return (
      <div className="gallery">
        <section className="loading-section-wrapper">
          <div className="container">
            <div className="row mb--2">
              <div className="col" style={{ textAlign: 'center' }}>
                <b><FontAwesomeIcon icon={faSpinner} spin /> Sedang memuat halaman</b>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }

  return (
    <div className="gallery">
      <section className="section-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div>
                <h1 className="hero-text-big-gallery">Dapatkan Promo menarik</h1>
              </div>
            </div>
            <div className="col-md-6">
              <div className="center">
                <img src={isCar ? require('../assets/img/bannerPromoMobil.png') : require('../assets/img/bannerPromoMotor.png')} alt=""/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="section-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="gallery-filter">
                <div className="gallery-filter-section">
                  <div className="gallery-filter-title">
                    <div>
                      <p className="mb--0">Filter</p>
                    </div>
                    <div>
                      <a onClick={() => resetFilter()}><p className="mb--0 text--weight-500 text--color-gold cursor-pointer">Reset</p></a>
                    </div>
                  </div>
                  <div className="gallery-filter-item">
                    <label htmlFor="price">HARGA</label>
                    <div>
                      <Radio name={isCar ? priceOptions.name : priceBikeOptions.name} options={isCar ? priceOptions.items : priceBikeOptions.items} value={priceFilter} onChange={(e) => onChangeFilter("price", e)} />
                    </div>
                  </div>
                </div>
                <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <Select
                      id="brand"
                      label="MEREK"
                      value={brandFilter}
                      options={isCar ? carBrand : bikeBrand}
                      onChange={(e) => onChangeFilter("brand", e)}
                    />
                  </div>
                </div>
                {/* <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <Select
                      id="model"
                      label="MODEL"
                      value="Pilih model"
                      options={[
                        {
                          value: 'Civic',
                          label: 'Civic'
                        },
                        {
                          value: 'Supra',
                          label: 'Supra'
                        }
                      ]}
                    />
                  </div>
                </div> */}
                <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <Select
                      id="year"
                      label="TAHUN"
                      value={yearFilter == "" ? "Pilih Tahun" : yearFilter}
                      options={isCar ? carYear : bikeYear}
                      onChange={(e) => onChangeFilter("year", e)}
                    />
                  </div>
                </div>
                <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <Select
                      id="color"
                      label="WARNA"
                      value={colorFilter == "" ? "Pilih Warna" : colorFilter}
                      options={colorOption}
                      onChange={(e) => onChangeFilter("color", e)}
                    />
                  </div>
                </div>
                <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <Select
                      id="location"
                      label="LOKASI"
                      value={cityFilter == "" ? "Pilih Warna" : cityFilter}
                      options={isCar ? carCities : bikeCities}
                      onChange={(e) => onChangeFilter("city", e)}
                    />
                  </div>
                </div>
                {/* <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <label htmlFor="price">JARAK TEMPUH</label>
                    <div className="gallery-filter-distance">
                      <div>
                        <input type="number" id="brand" name="brand" placeholder="Ketik Min" />
                      </div>
                      <div>
                        <span className="mr--1 ml--1">-</span>
                      </div>
                      <div>
                        <input type="number" id="brand" name="brand" placeholder="Ketik Max" />
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <label htmlFor="price">KONDISI</label>
                    <div className="gallery-filter-radio-oneline">
                      <Radio name={conditionOptions.name} options={isCar ? carConditions : bikeConditions} value={conditionFilter} onChange={(e) => onChangeFilter("condition", e)} />
                    </div>
                  </div>
                </div>
                {/* <div className="gallery-filter-section">
                  <div className="gallery-filter-item">
                    <label htmlFor="price">DEALS</label>
                    <div className="gallery-filter-radio-oneline">
                      <Radio name={dealOptions.name} options={dealOptions.items} onChange={(e) => console.log(e)} />
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="col-md-8">
              {products.length == 0 && (
                <div className="gallery">
                  <section className="loading-section-wrapper">
                    <div className="container">
                      <div className="row mb--2">
                        <div className="col" style={{ textAlign: 'center' }}>
                          <b><FontAwesomeIcon icon={faExclamationCircle} />Opps. Pilihan kamu tidak tersedia, silahkan pemilihan ulang</b>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
                )}
              <div className="row justify-content-between">
                {/* <div className="col-md-3">
                  <div className="gallery-product-search">
                    <input type="text" id="brand" name="brand" placeholder="Ketik Merek" />
                    <div className="gallery-product-search-icon">
                      <span className="text--color-gold"><FontAwesomeIcon icon={faSearch} /></span>
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-md-3">
                  <div className="gallery-sort-wrapper">
                    <Select
                      value="Sortir"
                      options={[
                        {
                          value: 'Harga',
                          label: 'Harga'
                        },
                        {
                          value: 'Tanggal',
                          label: 'Tanggal'
                        }
                      ]}
                    />
                  </div>
                </div> */}
              </div>
              <div className="row">
                {/* TEMP */}
                {products.map((d) => (
                  <div className="col-md-4" key={d.id}>
                    <div className="gallery-product-item">
                      <Link to={`/${isCar ? "mobil" : "motor"}/${d.id}`}>
                        <ProductItem
                          name={`${d.year} ${isCar ? d.CarType.brand_name : d.BikeType.brand_name}`}
                          image={d.images[0]}
                          detail={{
                            id: d.id,
                            isCar: isCar,
                            year: d.year,
                            type: `${isCar ? `${d.CarType.specification} ${d.CarType.type} ${d.CarType.transmission == 'Manual' ? "MT" : "AT"} ${d.class ? d.class : ""}` : `${d.BikeType.type}`}`,
                            location: d.City.name,
                            price: d.price,
                            condition: d.condition,
                            mileage: `${splitThousand(d.mileage)} km`,
                            installment: `${setInstallmentString(d.installment)}/bln`,
                            belowMarketPrice: d.belowMarkret
                          }}
                        />
                      </Link>
                    </div>
                  </div>
                )) }
              </div>
              <div className="row">
                <div className="col">
                  <div>
                    <Pagination
                      page={totalPage}
                      onPageChange={onChangePage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Gallery